import React from 'react';
import { CtaButton } from '../CtaButton';
import { AUTHOR_IMAGE, methodSteps } from '../../data/content';
const questions = ['Where do I start?', 'What do I need to review?', 'What decision am I making?', 'What should I reassess?'];
export function About() {
  return <section className="w-full bg-blush px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="about-title" data-id="element-76" data-mp="ypl5ekxw2utf">
      <div className="mx-auto max-w-5xl" data-id="element-77" data-mp="azhdvbxz6lis">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,320px)_minmax(0,1fr)] lg:items-start lg:gap-12" data-id="element-78" data-mp="b0ir9n2grk3o">
          <figure className="mx-auto w-full max-w-[320px] lg:sticky lg:top-8" data-id="element-79" data-mp="627ilfnwnfn1">
            <img src={AUTHOR_IMAGE} alt="Dr. Karito, creator of 5-MIN MENOPAUSE™, wearing a white medical coat in her clinic" className="w-full rounded-3xl border border-navy/10 object-cover" loading="lazy" data-id="element-80" data-mp="jt2r2quhruq3" />
            <figcaption className="mt-3 text-center" data-id="element-81" data-mp="3jg2hed7u8mei">
              <span className="block font-display text-[20px] font-bold text-navy" data-id="element-82" data-mp="3jdg92bd4i2v8">
                Dr. Karito
              </span>
              <span className="block text-[12px] font-extrabold uppercase tracking-[0.12em] text-rose" data-id="element-83" data-mp="3881sxyv09o23">
                Creator of 5-MIN MENOPAUSE™
              </span>
            </figcaption>
          </figure>

          <div data-id="element-84" data-mp="3hyo1xa87vgbt">
            <p className="text-[12px] font-extrabold uppercase tracking-[0.12em] text-rose" data-id="element-85" data-mp="3hx39bq5gq7gl">
              About Dr. Karito
            </p>
            <h2 id="about-title" className="mt-2 font-display text-[28px] font-bold leading-[1.15] text-navy sm:text-4xl" data-id="element-86" data-mp="2kch0uab4g647">
              Why did Dr. Karito create 5-MIN MENOPAUSE™?
            </h2>

            <div className="mt-5 space-y-3.5 text-[15px] leading-relaxed text-navy/75 sm:text-[16.5px]" data-id="element-87" data-mp="2z86f1ma2feyd">
              <p data-id="element-88" data-mp="9j4dqpmeko3m">
                After working with menopause-related clinical questions, Dr. Karito recognized a
                problem shared by many physicians:
              </p>
              <p className="border-l-2 border-rose pl-4 font-semibold text-navy" data-id="element-89" data-mp="2akap0serj7q6">
                The problem isn’t always lack of information. It’s the difficulty of turning a large
                amount of information into a structured process during a real patient visit.
              </p>
              <p data-id="element-90" data-mp="2fjwziu37i9va">
                Guidelines, scientific publications, recommendations, and clinical resources can
                contain valuable information. But when a patient is sitting in front of you, you
                need to know:
              </p>
            </div>

            <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-91" data-mp="1mt5624dizzbn">
              {questions.map(question => <li key={question} className="rounded-xl bg-white px-4 py-3 font-display text-[15.5px] font-semibold italic text-navy" data-id="element-92" data-mp="1vvo7ql5ks5wb">
                  {question}
                </li>)}
            </ul>

            <div className="mt-6 space-y-3.5 text-[15px] leading-relaxed text-navy/75 sm:text-[16.5px]" data-id="element-93" data-mp="1448e475lpiwl">
              <p data-id="element-94" data-mp="tygtbamxwo03">
                That’s why Dr. Karito created 5-MIN MENOPAUSE™. Not as another long course. Not as
                another textbook. But as a practical clinical framework built around five simple
                stages:
              </p>
            </div>

            <ol className="mt-5 grid gap-2.5 sm:grid-cols-5" data-id="element-95" data-mp="p28gw504n8wm">
              {methodSteps.map((step, index) => <li key={step} className="flex items-center gap-2.5 rounded-xl bg-navy px-4 py-3 sm:flex-col sm:gap-1.5 sm:px-2 sm:py-4 sm:text-center" data-id="element-96" data-mp="1crt2kvno0k9l" data-mpi={index}>
                  <span className="font-display text-[18px] font-bold leading-none text-rose-light" data-id="element-97" data-mp="12uy7kmqlp202">
                    {index + 1}
                  </span>
                  <span className="text-[13px] font-extrabold uppercase tracking-wide text-white" data-id="element-98" data-mp="3ni1e2xwla49h">
                    {step}
                  </span>
                </li>)}
            </ol>

            <p className="mt-6 text-[15px] leading-relaxed text-navy/75 sm:text-[16.5px]" data-id="element-99" data-mp="ckzd5rp71hcr">
              The goal isn’t to make you study more. The goal is to help you organize clinical
              information into a repeatable process.
            </p>

            <div className="mt-8 max-w-xl" data-id="element-100" data-mp="3u0fo28du6ydd">
              <CtaButton label="Yes, show me 5-MIN MENOPAUSE™" subtext="One-time $27 · Instant access · Lifetime access" data-id="element-101" data-mp="3u1h28lq5g0zb" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}